import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Participation|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryParticipation';
export type SPCandidateHistoryParticipationLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelUpdated`
	| `${LocNameStart}LabelReviewStatus`
	| `${LocNameStart}LabelInvalid`
	| `${LocNameStart}LabelDataProvider`
	| `${LocNameStart}LabelDocumentation`;

export const spCandidateHistoryParticipationLocs: LocDefs<SPCandidateHistoryParticipationLocNames> =
	{
		SPCandidateHistoryParticipationTitleTab: {
			defaultValue: 'Participation',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			legacyName: 'OtherRequirement/Candidates.Enrollment.Title.Tab',
			...sharedProperties,
		},
		SPCandidateHistoryParticipationTitleSection: {
			defaultValue: 'Participation',
			description: 'Section Title',
			displayPath: `${pathStart}Section Title`,
			displayType: 'Title',
			legacyName: 'OtherRequirement/Candidates.Participation.Title.PageSectionTitle',
			...sharedProperties,
		},
		SPCandidateHistoryParticipationLabelName: {
			defaultValue: 'Name',
			description: 'Column heading for: Name.',
			displayPath: `${pathStart}Name`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Participation.ColumnHeading.Name',
			...sharedProperties,
		},
		SPCandidateHistoryParticipationLabelActiveDate: {
			defaultValue: 'Active Date',
			description: 'Column heading for: Active Date.',
			displayPath: `${pathStart}Active Date`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Participation.ColumnHeading.ActiveDate',
			...sharedProperties,
		},
		SPCandidateHistoryParticipationLabelExpireDate: {
			defaultValue: 'Expire Date',
			description: 'Column heading for: Expire Date.',
			displayPath: `${pathStart}Expire Date`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Participation.ColumnHeading.ExpireDate',
			...sharedProperties,
		},
		SPCandidateHistoryParticipationLabelUpdated: {
			defaultValue: 'Updated',
			description: 'Column heading for: Updated.',
			displayPath: `${pathStart}Updated`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Participation.ColumnHeading.Updated',
			...sharedProperties,
		},
		SPCandidateHistoryParticipationLabelReviewStatus: {
			defaultValue: 'Review Status',
			description: 'Column heading for: Review Status.',
			displayPath: `${pathStart}Review Status`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Participation.ColumnHeading.ReviewStatus',
			...sharedProperties,
		},
		SPCandidateHistoryParticipationLabelInvalid: {
			defaultValue: 'Invalid',
			description: 'Column heading for: Invalid.',
			displayPath: `${pathStart}Invalid`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Participation.ColumnHeading.Invalid',
			...sharedProperties,
		},
		SPCandidateHistoryParticipationLabelDataProvider: {
			defaultValue: 'Data Provider',
			description: 'Column heading for: Data Provider.',
			displayPath: `${pathStart}Data Provider`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Participation.ColumnHeading.DataProvider',
			...sharedProperties,
		},
		SPCandidateHistoryParticipationLabelDocumentation: {
			defaultValue: 'Documentation',
			description: 'Column heading for: Documentation.',
			displayPath: `${pathStart}Documentation`,
			displayType: 'Label',
			legacyName: 'OtherRequirement/Candidates.Participation.ColumnHeading.Documentation',
			...sharedProperties,
		},
	};

export type SPCandidateHistoryParticipationLocType =
	LocMap<SPCandidateHistoryParticipationLocNames>;
